import './download.scss';
import { initDownloads } from '@assets/JavaScript/modules/download.js';

initDownloads();
